import { render, staticRenderFns } from "./videoHome.vue?vue&type=template&id=55ad2aa2&scoped=true&"
import script from "./videoHome.vue?vue&type=script&lang=js&"
export * from "./videoHome.vue?vue&type=script&lang=js&"
import style0 from "./videoHome.vue?vue&type=style&index=0&id=55ad2aa2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad2aa2",
  null
  
)

export default component.exports